import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Logo } from "@/components/Logo";
import { SITE, emailOf } from "@/content/site";

const Col = ({ title, children }) => (
  <div>
    <h3 className="mb-5 text-xs font-semibold uppercase tracking-[0.22em] text-[#C59B27]">{title}</h3>
    {children}
  </div>
);

export const Footer = () => {
  const { t, lang, lp } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#0F2138] text-[#C9D4E1]">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8 lg:px-12">
        <div className="grid gap-12 border-b border-white/10 pb-14 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo light lang={lang} testId="footer-logo-placeholder" label={t.common.logoPlaceholder} />
            <p className="mt-6 max-w-sm text-sm leading-relaxed">{t.footer.desc}</p>
          </div>
          <div className="lg:col-span-3">
            <Col title={t.footer.locations}>
              <ul className="space-y-3 text-sm">
                {["julyana", "sirte"].map((k) => (
                  <li key={k} className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#8EA3BC]" aria-hidden="true" />
                    <span><span className="text-white">{t.locationsShort[k].name}</span><br />{t.locationsShort[k].city}, {lang === "ar" ? "ليبيا" : "Libya"}</span>
                  </li>
                ))}
              </ul>
            </Col>
          </div>
          <div className="lg:col-span-3">
            <Col title={t.footer.contact}>
              <ul className="space-y-3 text-sm">
                <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 text-[#8EA3BC]" aria-hidden="true" />{lang === "ar" ? "بنغازي، ليبيا" : "Benghazi, Libya"}</li>
                {SITE.phone && <li className="flex gap-3"><Phone className="mt-0.5 h-4 w-4 text-[#8EA3BC]" aria-hidden="true" /><a href={SITE.phoneHref} dir="ltr" className="hover:text-white" data-testid="footer-phone">{SITE.phone}</a></li>}
                {SITE.emailsLive && SITE.emails.map((b) => (
                  <li key={b} className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 text-[#8EA3BC]" aria-hidden="true" /><a href={`mailto:${emailOf(b)}`} dir="ltr" className="hover:text-white" data-testid={`footer-email-${b}`}>{emailOf(b)}</a></li>
                ))}
                <li className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 text-[#8EA3BC]" aria-hidden="true" /><Link to={lp("/contact")} className="hover:text-white" data-testid="footer-contact-link">{t.nav.contact}</Link></li>
                <li className="flex gap-3"><Mail className="mt-0.5 h-4 w-4 text-[#8EA3BC]" aria-hidden="true" /><Link to={lp("/quote")} className="hover:text-white" data-testid="footer-quote-link">{t.nav.quote}</Link></li>
              </ul>
            </Col>
          </div>
          <div className="lg:col-span-2">
            <Col title={t.footer.services}>
              <ul className="space-y-3 text-sm">
                {t.services.map((s) => (
                  <li key={s.slug}><Link to={lp(`/services/${s.slug}`)} className="hover:text-white" data-testid={`footer-service-${s.slug}`}>{s.title}</Link></li>
                ))}
              </ul>
            </Col>
          </div>
        </div>
        <div className="flex flex-col gap-4 pt-8 text-xs md:flex-row md:items-center md:justify-between">
          {SITE.crNo && SITE.licNo ? <p data-testid="footer-registration">{t.footer.cr} <span dir="ltr">{SITE.crNo}</span> · {t.footer.lic} <span dir="ltr">{SITE.licNo}</span></p> : <span />}
          <p>© {year} Atlas Bridge Logistics. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
